import { render } from "./iFrame.vue?vue&type=template&id=e38c97d6&scoped=true"
import script from "./iFrame.vue?vue&type=script&lang=js"
export * from "./iFrame.vue?vue&type=script&lang=js"

import "./iFrame.vue?vue&type=style&index=0&id=e38c97d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38c97d6"]])

export default __exports__